/* unplugin-vue-components disabled */import script from "./RoleManager.vue?vue&type=script&setup=true&lang=js"
export * from "./RoleManager.vue?vue&type=script&setup=true&lang=js"

import "./RoleManager.vue?vue&type=style&index=0&id=624816e3&scoped=true&lang=less"

import exportComponent from "/Users/zhangxuan/Documents/Projects/VinesDjango/frontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-624816e3"]])

export default __exports__